"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AhoCorasick {
    constructor(keywords) {
        this.gotoFn = {
            0: {},
        };
        this.output = {};
        this.failure = {};
        this._buildTables(keywords);
    }
    _buildTables(keywords) {
        const gotoFn = this.gotoFn;
        const output = this.output;
        const failure = this.failure;
        let state = 0;
        keywords.forEach((word) => {
            if (!word || word === "0")
                return;
            let curr = 0;
            for (let i = 0; i < word.length; i++) {
                const l = word[i];
                if (gotoFn[curr] && l in gotoFn[curr]) {
                    curr = gotoFn[curr][l];
                }
                else {
                    state++;
                    gotoFn[curr][l] = state;
                    gotoFn[state] = {};
                    curr = state;
                    output[state] = [];
                }
            }
            output[curr].push(word);
        });
        const xs = [];
        for (const l in gotoFn[0]) {
            const state = gotoFn[0][l];
            failure[state] = 0;
            xs.push(state);
        }
        while (xs.length) {
            const r = xs.shift();
            for (const l in gotoFn[r]) {
                const s = gotoFn[r][l];
                xs.push(s);
                let state = failure[r];
                while (state > 0 && !(l in gotoFn[state])) {
                    state = failure[state];
                }
                if (l in gotoFn[state]) {
                    const fs = gotoFn[state][l];
                    failure[s] = fs;
                    output[s] = output[s].concat(output[fs]);
                }
                else {
                    failure[s] = 0;
                }
            }
        }
        this.gotoFn = gotoFn;
        this.output = output;
        this.failure = failure;
    }
    search(string) {
        let state = 0;
        const results = [];
        for (let i = 0; i < string.length; i++) {
            const l = string[i];
            while (state > 0 && !(l in this.gotoFn[state])) {
                state = this.failure[state];
            }
            if (!(l in this.gotoFn[state])) {
                continue;
            }
            state = this.gotoFn[state][l];
            if (this.output[state].length) {
                const foundStrs = this.output[state];
                results.push([i, foundStrs]);
            }
        }
        return results;
    }
}
exports.default = AhoCorasick;
